import styled from 'styled-components'
import Text from './Text'
const Container = styled.button`
  width: ${({ $fullWidth }) => $fullWidth === false ? 'auto' : '100%'};
  white-space: nowrap;
  height: ${({ $size }) => $size === 'small' ? '44px' : '50px'};
  padding: ${({ $compact, $size }) =>
    $compact ? '8px 12px' :
    $size === 'small' ? '8px 12px' :
    '12px 16px'};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  background-color: ${({ theme, $variant, disabled }) => {
    if (disabled) return theme.colors.neutral[400];
    if ($variant === "secondary") return theme.colors.secondary;
    if ($variant === "cancel") return theme.colors.neutral[300];
    if ($variant === "destructive") return theme.colors.status.error;
    return theme.colors.primary;
  }};
`

const MainButton = ({title, $variant, $fullWidth, $size, $compact, type, disabled=false, onClick, }) => {
  const textColor = $variant === "cancel" ? "normal" : "inverse";

  return (
    <Container 
      $variant={$variant}
      $fullWidth={$fullWidth}
      $size={$size}
      $compact={$compact}
      disabled={disabled}
      onClick={onClick}
      type={type || "button"}
    >
      <Text weight="medium" color={textColor}>
        {title}
      </Text>
    </Container>
  )
}

export default MainButton
